import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasError',
})(({ theme, hasError }) => ({
  marginTop: theme.spacing(2),
  border: `1px solid ${hasError ? theme.palette.error.main : theme.palette.action.disabledBackground}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
}));

export const Label = styled('div')(({ theme }) => ({
  fontSize: 13,
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const CanvasWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 150,
  border: `1px dashed ${theme.palette.action.disabled}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const canvasClass = 'signature-pad-canvas';

// Apply canvas styling globally so we can pass `signature-pad-canvas` as a className to react-signature-canvas.
// Inject styles via global selector through a styled wrapper class.
export const CanvasStyleHelper = styled('div')({
  [`& .${canvasClass}`]: {
    width: '100%',
    height: '100%',
    cursor: 'crosshair',
  },
});

export const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

export const SaveButton = styled(Button)({
  minWidth: 80,
});

export const Preview = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const PreviewImage = styled('img')(({ theme }) => ({
  height: 60,
  border: `1px solid ${theme.palette.action.disabledBackground}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const Timestamp = styled('span')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
}));
